<template>
  <div
    class="p-3 rounded-large w-fit bg-secondary-container text-on-secondary-container rounded-tl-extra-small"
  >
    <WysiwygTextFieldReadOnly
      v-if="initialValue"
      :value="initialValue"
      class="text-body-medium w-fit"
    />
  </div>
</template>

<script setup lang="ts">
import type { JSONContent } from '@tiptap/vue-3'
import WysiwygTextFieldReadOnly from '@/core/components/base/wysiwyg/WysiwygTextFieldReadOnly.vue'

interface Props {
  initialValue: JSONContent | undefined
}
defineProps<Props>()
</script>
